/* OMEVEX — interacciones propias (vanilla, sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal--img, .mt-pasos');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reducido) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var f = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var centro = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--mt-parallax', (centro * -f).toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
    pintar();
  }

  function contar(el) {
    if (el.dataset.mtHecho) return;
    el.dataset.mtHecho = '1';
    var fin = parseFloat(el.getAttribute('data-mt-count'));
    if (isNaN(fin) || reducido) { el.textContent = el.getAttribute('data-mt-count'); return; }
    var t0 = null, dur = 1400;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = Math.round(v);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initFunciones() {
    document.querySelectorAll('[data-mt-funciones]').forEach(function (sec) {
      var items = sec.querySelectorAll('.mt-funcion');
      var imgs = sec.querySelectorAll('.mt-funciones__marco img');
      var puntos = sec.querySelectorAll('.mt-funciones__puntos span');
      function activar(i) {
        items.forEach(function (it, j) { it.classList.toggle('mt-activa', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('mt-activa', j === i); });
        puntos.forEach(function (pt, j) { pt.classList.toggle('mt-activa', j === i); });
        var c = items[i] && items[i].querySelector('[data-mt-count]');
        if (c) contar(c);
      }
      if (!('IntersectionObserver' in window)) { activar(0); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(items, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { io.observe(it); });
      activar(0);
      // En móvil todas las cifras se cuentan al aparecer
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) contar(e.target); });
      }, { threshold: 0.6 });
      sec.querySelectorAll('[data-mt-count]').forEach(function (c) { io2.observe(c); });
    });
  }

  function initFaq() {
    document.querySelectorAll('.mt-faq__item, .mt-acordeon details').forEach(function (d) {
      var sum = d.querySelector('summary');
      var cuerpo = sum && sum.nextElementSibling;
      if (!cuerpo || reducido || !cuerpo.animate) return;
      sum.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          var h = cuerpo.offsetHeight;
          cuerpo.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' })
            .onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = cuerpo.offsetHeight;
          cuerpo.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      var grandes = g.querySelectorAll('.mt-galeria__principal img');
      var minis = g.querySelectorAll('.mt-galeria__mini');
      var actual = 0;
      function ir(i) {
        if (!grandes.length) return;
        actual = (i + grandes.length) % grandes.length;
        grandes.forEach(function (im, j) { im.classList.toggle('mt-activa', j === actual); });
        minis.forEach(function (m, j) { m.classList.toggle('mt-activa', j === actual); });
        if (minis[actual]) minis[actual].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
      var prev = g.querySelector('[data-mt-prev]'), next = g.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null, principal = g.querySelector('.mt-galeria__principal');
      if (principal) {
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      var datos = sec.querySelector('[data-mt-variantes-json]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('[data-mt-precio]');
      var tachado = sec.querySelector('[data-mt-tachado]');
      var ahorro = sec.querySelector('[data-mt-ahorro]');
      var botones = sec.querySelectorAll('[data-mt-boton]');
      var stickyPrecio = document.querySelector('[data-mt-sticky-precio]');
      var formato = sec.getAttribute('data-mt-moneda') || '${{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
      }
      function aplicar(id) {
        var v = variantes.find(function (x) { return String(x.id) === String(id); });
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (stickyPrecio) stickyPrecio.textContent = dinero(v.price);
        var hay = v.compare_at_price && v.compare_at_price > v.price;
        if (tachado) { tachado.textContent = hay ? dinero(v.compare_at_price) : ''; tachado.hidden = !hay; }
        if (ahorro) { ahorro.hidden = !hay; if (hay) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('[data-mt-boton-texto]');
          if (t) t.textContent = v.available ? b.getAttribute('data-mt-texto') : b.getAttribute('data-mt-agotado');
        });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      sec.querySelectorAll('input[name="mt-variante"]').forEach(function (r) {
        r.addEventListener('change', function () { aplicar(r.value); });
      });
      var marcado = sec.querySelector('input[name="mt-variante"]:checked');
      if (marcado) aplicar(marcado.value);

      // En el editor de Shopify no se puede ir al carrito ni al pago (da error de "agotado"/"URL no compatible"):
      // allí los botones no envían el formulario y muestran un aviso.
      var form = sec.querySelector('form[action*="/cart/add"]');
      if (form && window.Shopify && window.Shopify.designMode) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var aviso = sec.querySelector('.mt-aviso-editor');
          if (!aviso) {
            aviso = document.createElement('p');
            aviso.className = 'mt-aviso-editor';
            aviso.textContent = 'Estás en el editor: aquí no se puede comprar. Prueba los botones en tu tienda (Ver tienda).';
            form.appendChild(aviso);
          }
        });
      }

      // "Comprar ahora": mismo formulario, pero va directo al pago
      var rapido = sec.querySelector('[data-mt-directo]');
      if (rapido) rapido.addEventListener('click', function () {
        var ret = sec.querySelector('input[name="return_to"]');
        if (ret) ret.disabled = false;
      });
      // Al volver atrás desde el pago, que 'Añadir al carrito' no vaya directo al pago
      window.addEventListener('pageshow', function () { var r = sec.querySelector('input[name="return_to"]'); if (r) r.disabled = true; });

      // Barra de compra fija al bajar
      var barra = document.querySelector('.mt-sticky-compra');
      var ancla = sec.querySelector('.mt-compra__acciones');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          barra.classList.toggle('mt-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(ancla);
        var btn = barra.querySelector('button');
        if (btn) btn.addEventListener('click', function () { ancla.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }

  // Opiniones: carrusel infinito (se para al pasar el ratón, se puede arrastrar) + visor
  function initResenas() {
    document.querySelectorAll('[data-mt-resenas]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var carrusel = sec.querySelector('[data-mt-carrusel]');
      var pista = sec.querySelector('[data-mt-pista]');
      if (!carrusel || !pista) return;
      var originales = Array.prototype.slice.call(pista.children);

      // Copias para el bucle infinito (las copias no se leen con lector de pantalla)
      for (var c = 0; c < 2; c++) {
        originales.forEach(function (el) {
          var copia = el.cloneNode(true);
          copia.setAttribute('aria-hidden', 'true');
          copia.removeAttribute('tabindex');
          copia.removeAttribute('data-shopify-editor-block');
          pista.appendChild(copia);
        });
      }

      var vel = parseFloat(getComputedStyle(sec).getPropertyValue('--mt-vel-px')) || 0;
      if (reducido) vel = 0;
      var pos = 0, ancho = 0, pausa = false, arrastre = null, movido = 0, ultimo = performance.now();
      function medir() { ancho = pista.scrollWidth / 3; }
      medir();
      window.addEventListener('resize', medir);
      pista.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', medir, { once: true }); });

      function normalizar() { if (ancho > 0) { while (pos <= -ancho) pos += ancho; while (pos > 0) pos -= ancho; } }
      function bucle(t) {
        var dt = Math.min((t - ultimo) / 1000, 0.05);
        ultimo = t;
        if (!pausa && !arrastre && ancho > 0) { pos -= vel * dt; normalizar(); }
        pista.style.transform = 'translate3d(' + pos.toFixed(2) + 'px,0,0)';
        requestAnimationFrame(bucle);
      }
      requestAnimationFrame(bucle);
      document.addEventListener('visibilitychange', function () { ultimo = performance.now(); });

      carrusel.addEventListener('mouseenter', function () { pausa = true; });
      carrusel.addEventListener('mouseleave', function () { pausa = false; });
      carrusel.addEventListener('pointerdown', function (e) {
        arrastre = { x: e.clientX, p: pos }; movido = 0;
        carrusel.classList.add('mt-arrastrando');
      });
      window.addEventListener('pointermove', function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        movido = Math.max(movido, Math.abs(dx));
        pos = arrastre.p + dx; normalizar();
      });
      window.addEventListener('pointerup', function () {
        if (!arrastre) return;
        arrastre = null;
        carrusel.classList.remove('mt-arrastrando');
        if (window.matchMedia('(hover: none)').matches) { pausa = true; setTimeout(function () { pausa = false; }, 2500); }
      });

      // Visor
      var visor = sec.querySelector('[data-mt-visor]');
      var vImg = sec.querySelector('[data-mt-visor-img]');
      var vTxt = sec.querySelector('[data-mt-visor-texto]');
      var actual = 0;
      if (visor && visor.parentElement !== document.body) document.body.appendChild(visor);
      function abrir(i) {
        actual = (i + originales.length) % originales.length;
        var card = originales[actual];
        var img = card.querySelector('img');
        vImg.src = img ? (img.getAttribute('data-mt-grande') || img.src) : '';
        vImg.alt = img ? img.alt : '';
        var est = card.querySelector('.mt-resena__completa .mt-estrellas');
        var frase = card.querySelector('.mt-resena__frase');
        var texto = card.querySelector('.mt-resena__texto');
        var autor = card.querySelector('.mt-resena__completa .mt-resena__autor');
        var chip = card.querySelector('.mt-resena__chip');
        var fecha = card.querySelector('.mt-resena__fecha');
        vTxt.innerHTML = '';
        if (est) vTxt.appendChild(est.cloneNode(true));
        if (frase) { var p1 = document.createElement('p'); p1.className = 'mt-visor__cita'; p1.textContent = frase.textContent; vTxt.appendChild(p1); }
        if (texto) { var p2 = document.createElement('p'); p2.innerHTML = texto.innerHTML; vTxt.appendChild(p2); }
        if (autor) { var p3 = document.createElement('p'); p3.className = 'mt-visor__autor'; p3.textContent = autor.textContent; vTxt.appendChild(p3); }
        var meta = [chip && chip.textContent, fecha && fecha.textContent].filter(Boolean).join(' · ');
        if (meta) { var p4 = document.createElement('p'); p4.className = 'mt-visor__meta'; p4.textContent = meta; vTxt.appendChild(p4); }
        visor.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        pausa = true;
      }
      function cerrar() { visor.hidden = true; document.documentElement.style.overflow = ''; pausa = false; }
      pista.addEventListener('click', function (e) {
        var card = e.target.closest('[data-mt-resena]');
        if (!card || movido > 6) return;
        abrir(parseInt(card.getAttribute('data-mt-resena'), 10));
      });
      pista.addEventListener('keydown', function (e) {
        var card = e.target.closest('[data-mt-resena]');
        if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); abrir(parseInt(card.getAttribute('data-mt-resena'), 10)); }
      });
      if (visor) {
        visor.querySelectorAll('[data-mt-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
        visor.querySelector('[data-mt-visor-prev]').addEventListener('click', function () { abrir(actual - 1); });
        visor.querySelector('[data-mt-visor-next]').addEventListener('click', function () { abrir(actual + 1); });
        document.addEventListener('keydown', function (e) {
          if (visor.hidden) return;
          if (e.key === 'Escape') cerrar();
          if (e.key === 'ArrowRight') abrir(actual + 1);
          if (e.key === 'ArrowLeft') abrir(actual - 1);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.remove('mt-no-js');
    initReveal();
    initParallax();
    initFunciones();
    initFaq();
    initGaleria();
    initProducto();
    initResenas();
  });

  // En el editor de Shopify, re-iniciar al añadir/editar secciones
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initParallax(); initFunciones(); initFaq(); initGaleria(); initProducto(); initResenas();
  });
})();
